import { useEffect, useState } from "react";

/**
 * Subscribe to a CSS media query. Use it when behaviour — not just styling —
 * depends on a breakpoint, e.g. a control that only makes sense while a
 * `hidden xl:flex` pane is actually on screen.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => window.matchMedia?.(query).matches ?? false,
  );

  useEffect(() => {
    const list = window.matchMedia?.(query);
    if (!list) return;
    setMatches(list.matches);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
